import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const DELETE_ITEM = `${NAME}/DELETE_ITEM`;
export const DELETE_ITEM_SUCCESS = `${NAME}/DELETE_ITEM_SUCCESS`;
export const DELETE_ITEM_FAILURE = `${NAME}/DELETE_ITEM_FAILURE`;

export const FETCH_COUNTRIES_ITEMS = `${NAME}/FETCH_COUNTRIES_ITEMS`;
export const FETCH_COUNTRIES_ITEMS_FAILURE = `${NAME}/FETCH_COUNTRIES_ITEMS_FAILURE`;
export const FETCH_COUNTRIES_ITEMS_SUCCESS = `${NAME}/FETCH_COUNTRIES_ITEMS_SUCCESS`;

export const FETCH_PRODUCTS = `${NAME}/FETCH_PRODUCTS`;
export const FETCH_PRODUCTS_SUCCESS = `${NAME}/FETCH_PRODUCTS_SUCCESS`;
export const FETCH_PRODUCTS_FAILURE = `${NAME}/FETCH_PRODUCTS_FAILURE`;

export const FETCH_TEMPLATES = `${NAME}/FETCH_TEMPLATES`;
export const FETCH_TEMPLATES_SUCCESS = `${NAME}/FETCH_TEMPLATES_SUCCESS`;
export const FETCH_TEMPLATES_FAILURE = `${NAME}/FETCH_TEMPLATES_FAILURE`;

export const FETCH_ITEMS = `${NAME}/FETCH_ITEMS`;
export const FETCH_ITEMS_SUCCESS = `${NAME}/FETCH_ITEMS_SUCCESS`;
export const FETCH_ITEMS_FAILURE = `${NAME}/FETCH_ITEMS_FAILURE`;

export const FETCH_ITEM = `${NAME}/FETCH_ITEM`;
export const FETCH_ITEM_SUCCESS = `${NAME}/FETCH_ITEM_SUCCESS`;
export const FETCH_ITEM_FAILURE = `${NAME}/FETCH_ITEM_FAILURE`;

export const FETCH_ROOF_TYPES = `${NAME}/FETCH_ROOF_TYPES`;
export const FETCH_ROOF_TYPES_FAILURE = `${NAME}/FETCH_ROOF_TYPES_FAILURE`;
export const FETCH_ROOF_TYPES_SUCCESS = `${NAME}/FETCH_ROOF_TYPES_SUCCESS`;

export const FETCH_STRUCTURES = `${NAME}/FETCH_STRUCTURES`;

export const INITIALIZE = `${NAME}/INITIALIZE`;
export const INITIALIZE_SUCCESS = `${NAME}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${NAME}/INITIALIZE_FAILURE`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const OPEN_MODAL_PRODUCT = `${NAME}/OPEN_MODAL_PRODUCT`;

export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_ITEM = `${NAME}/SAVE_ITEM`;
export const SAVE_ITEM_FAILURE = `${NAME}/SAVE_ITEM_FAILURE`;
export const SAVE_ITEM_SUCCESS = `${NAME}/SAVE_ITEM_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;

export const UPDATE_ITEMS_SUCCESS = `${NAME}/UPDATE_ITEMS_SUCCESS`;
